import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function MarketingHeader() {
  return (
    <header className="absolute top-0 left-0 right-0 z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-2xl bg-[var(--fcc-ink)] text-white flex items-center justify-center relative">
            <Heart className="w-4 h-4" />
            <span className="absolute -top-1 -right-1 w-2 h-2 bg-[var(--fcc-orange)] rounded-full" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-[22px] text-[var(--fcc-green)] tracking-tight">KidHQ</div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[var(--fcc-ink-soft)] -mt-0.5">AI Command Center</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[var(--fcc-ink-soft)]">
          <a href="#features" className="hover:text-[var(--fcc-ink)]">How it works</a>
          <a href="#timeline" className="hover:text-[var(--fcc-ink)]">Family timeline</a>
          <a href="#pricing" className="hover:text-[var(--fcc-ink)]">Pricing</a>
          <a href="#roadmap" className="hover:text-[var(--fcc-ink)]">Roadmap</a>
          <a href="#faq" className="hover:text-[var(--fcc-ink)]">FAQ</a>
        </nav>

        <Link to="/app" data-testid="header-try-demo" className="fcc-btn-primary text-sm py-2.5 px-5">
          Try the demo →
        </Link>
      </div>
    </header>
  );
}
